import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { Page } from "../model/Page";
import { CallCenterSearchModel } from "../model/CallCenterSearchModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CallCenterViewModel } from "../model/CallCenterViewModel";
import { ViewApplicationSearchModel } from "../model/ViewApplicationSearchModel";
import { ViewApplicationDetailModel } from "../model/ViewApplicationDetailModel";
import { CorrigendumUploadModel } from "../model/CorrigendumUploadModel";
import { Observable } from "rxjs";
import { FileResponseModel } from "../model/FileResponseModel";

@Injectable({
  providedIn: "root",
})
export class AddNomineeOfApplicationService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  fetchDetailView(applicationId: number) {
    return this.httpClient.get<ViewApplicationDetailModel>(
      ApiUrls.viewNomineeForm.replace(
        "{applicationId}",
        applicationId.toString()
      )
    );
  }

  fetchFilterList(page: number, size: number, filterText: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<ViewApplicationSearchModel>>(
      ApiUrls.addNomineeApplicationSearch + reqParams
    );
  }

  saveNomineeDtls(applicationId: number, nomineeName: string, nomineeGender: string, 
    nomineeAge: string, nomineePanNumber: string, orderFile: string | ArrayBuffer, 
    nomineeDocFile: string | ArrayBuffer, nomineeRelation: string){
    console.log("Before Back End Call DATA Check>> ");

    return this.httpClient.post<{ status: string; successMsg: string; errorMessage: string }>(
      ApiUrls.saveNomineeDtls, {
        applicationId: applicationId.toString(),
        newNomineeName : nomineeName.trim(),
        newNomineeGender : nomineeGender,
        newNomineeAge : nomineeAge,
        newNomineePanNumber : nomineePanNumber.trim(),
        orderFile : orderFile,
        newNomineeRelation : nomineeRelation,
        nomineeDocFile : nomineeDocFile,
      }
    );

  }

  generateUnsignedPOL(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateNomineeUnsignedPOL.replace('{applicationId}', applicationId.toString()));
  }

  generateUnsignedAllotmentLetter(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateNomineeUnsignedAllotmentLetter.replace('{applicationId}', applicationId.toString()));
  }

  generateUnsignedPossessionLetter(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateNomineeUnsignedPossessionLetter.replace('{applicationId}', applicationId.toString()));
  }
}
